import { Admin, Mapping, RoleMapping } from "../../Data/SideMenu/RouteMapping";
import { getUserRole,getUserEmail } from "../../Services/Shared.service";

const userRole = getUserRole();

const roleSideMenus={};
let isAdmin = false;
userRole.forEach(element=>{
  if(!RoleMapping[element]) return;
  if(element == Admin) {
    isAdmin = true;
    return;
  }
  RoleMapping[element].forEach(sidemenu=>{
    roleSideMenus[sidemenu.name]=sidemenu
  })
});

if(isAdmin){
  RoleMapping[Admin].forEach(sidemenu=>{
    roleSideMenus[sidemenu.name]=sidemenu
  })
}

const DashboardData=[]
const roleData=[]
const SettingsData=[]

for(let key in roleSideMenus){
  if(roleSideMenus[key]["label"] == "Dashboard"){
    DashboardData.push(roleSideMenus[key]);
  }else if (roleSideMenus[key]["label"] == "User Profile"){
    SettingsData.push(roleSideMenus[key]);
  }else{
    roleData.push(roleSideMenus[key]);
  }
}


const processData = [];

DashboardData.forEach((element) => {
  if (!Mapping[element.name]) return;
  const sidemenu = Mapping[element.name];
  let tempObj={};
  const subArr=[];
  if(element.children && element.children.length>0){
    element.children.forEach(childele=>{
      if (!Mapping[childele.name]) return;
      const submenu = Mapping[childele.name]
      subArr.push({
        title:childele.label,
        path:submenu.path,
        type:'link'
      })
    })
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'sub',
      children:subArr
    }
  }else{
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'link',
      path:sidemenu.path
    }
  }
  processData.push(tempObj)


});

roleData.forEach((element) => {
  if (!Mapping[element.name]) return;
  const sidemenu = Mapping[element.name];
  let tempObj={};
  const subArr=[];
  if(element.children && element.children.length>0){
    element.children.forEach(childele=>{
      if (!Mapping[childele.name]) return;
      const submenu = Mapping[childele.name]
      subArr.push({
        title:childele.label,
        path:submenu.path,
        type:'link'
      })
    })
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'sub',
      children:subArr
    }
  }else{
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'link',
      path:sidemenu.path
    }
  }
  processData.push(tempObj)


});

SettingsData.forEach((element) => {
  if (!Mapping[element.name]) return;
  const sidemenu = Mapping[element.name];
  let tempObj={};
  const subArr=[];
  if(element.children && element.children.length>0){
    element.children.forEach(childele=>{
      if (!Mapping[childele.name]) return;
      const submenu = Mapping[childele.name]
      subArr.push({
        title:childele.label,
        path:submenu.path,
        type:'link'
      })
    })
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'sub',
      children:subArr
    }
  }else{
    tempObj={
      title: element.label,
      icon: sidemenu.icon,
      type:'link',
      path:sidemenu.path
    }
  }
  processData.push(tempObj)


});

/**
 * Items:{
        title: "Booking",
        icon: Grid,
        type: "sub",
        children: [
          {
            title: "Booking History",
            path: `${process.env.PUBLIC_URL}/booking/booking-history`,
            type: "link",
          },
        ],
      },
 */

export const MENUITEMS = [
  {
    Items: processData,
  },
];
